import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M9 0a8.97 8.97 0 0 0-7.5 4.047V1.1L.3 2.3V6H4l1.2-1.2H2.447C3.836 2.641 6.248 1.2 9 1.2c4.301 0 7.8 3.499 7.8 7.8 0 .62-.081 1.221-.218 1.8h1.237A9 9 0 0 0 9 0zm3.8 13.2h2.753c-1.388 2.159-3.801 3.6-6.553 3.6-4.301 0-7.8-3.499-7.8-7.8 0-.62.081-1.221.218-1.8H.181A9 9 0 0 0 9 18a8.97 8.97 0 0 0 7.5-4.047V16.9l1.2-1.2V12H14l-1.2 1.2zm-7.177.023l7.6-7.6-.849-.848-7.6 7.6.849.848zM8.6 6.8a1.8 1.8 0 1 0-3.6 0 1.8 1.8 0 0 0 3.6 0zm-2.4 0a.6.6 0 1 1 1.201.001A.6.6 0 0 1 6.2 6.8zm3.2 4.4a1.8 1.8 0 1 0 3.6 0 1.8 1.8 0 0 0-3.6 0zm2.4 0a.6.6 0 1 1-1.201-.001.6.6 0 0 1 1.201.001z" />
  </svg>
);

export default SvgComponent;
